"use client";

import { c as _c } from "react/compiler-runtime";
import { useUserStore } from "@/stores/useAuthStore";
import { useMySubscription } from "@/queries/subscription";
import { useMyPurchasedTickets } from "@/queries/tickets";
export function useContentAccess(entityUuid) {
  const $ = _c(12);
  const {
    userProfile,
    isLoggedIn
  } = useUserStore();
  const {
    data: subscriptionData
  } = useMySubscription(isLoggedIn);
  const hasActiveSubscription = isLoggedIn && subscriptionData?.data?.is_active === true;
  const {
    data: purchasedTicketsData
  } = useMyPurchasedTickets(isLoggedIn);
  let t0;
  if ($[0] !== purchasedTicketsData?.data?.tickets) {
    t0 = purchasedTicketsData?.data?.tickets ?? [];
    $[0] = purchasedTicketsData?.data?.tickets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== entityUuid || $[3] !== t0) {
    let t2;
    if ($[5] !== entityUuid) {
      t2 = t => t?.entity_uuid === entityUuid && t?.is_active;
      $[5] = entityUuid;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = t0.some(t2);
    $[2] = entityUuid;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const hasActiveTicket = t1;
  let t2;
  if ($[7] !== hasActiveSubscription || $[8] !== hasActiveTicket || $[9] !== isLoggedIn || $[10] !== userProfile) {
    t2 = {
      userProfile,
      isLoggedIn,
      hasActiveSubscription,
      hasActiveTicket
    };
    $[7] = hasActiveSubscription;
    $[8] = hasActiveTicket;
    $[9] = isLoggedIn;
    $[10] = userProfile;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}